// F4 Report 11: Accessories Fitting Stage
import React, { useEffect, useState } from "react";
import { fetchReportAccessories } from "../../api/service";
import ReportShell, { display, fmtINR, downloadReportCsv } from "./ReportShell";

const AccessoriesReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [centre, setCentre] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetchReportAccessories(centre || null)
      .then((res) => { if (!alive) return; setRows(res?.rows || []); setCount(res?.count || 0); })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [centre]);

  return (
    <ReportShell
      title="11. Accessories Fitting Stage"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("exec_accessories", centre ? `?centre=${centre}` : "")}
    >
      <div className="d-flex align-items-center mb-3" style={{ gap: "0.5rem" }}>
        <label className="mb-0" style={{ fontWeight: 500 }}>Execution Centre:</label>
        <select
          className="form-select form-select-sm"
          style={{ maxWidth: "220px" }}
          value={centre}
          onChange={(e) => setCentre(e.target.value)}
        >
          <option value="">All Centres</option>
          <option value="bangalore">Bangalore</option>
          <option value="hyderabad">Hyderabad</option>
          <option value="mumbai">Mumbai</option>
          <option value="delhi">Delhi</option>
        </select>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Civil Engineer</th>
              <th className="text-center">Net Value (INR)</th>
              <th className="text-center">Ageing (days)</th>
              <th className="text-center">Execution Centre</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={5} className="text-center text-muted py-4">Nothing to report.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.civil_members)}</td>
                <td className="text-center">{fmtINR(r.net_value)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
                <td className="text-center">{r.execution_centre ? r.execution_centre.charAt(0).toUpperCase() + r.execution_centre.slice(1) : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default AccessoriesReport;
